import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule} from '@angular/forms';

import { AppComponent } from './app.component';
import { TarifComponent } from './tarif/tarif.component';

import { AppDateAdapter } from './format-datepicker';
import { GlobalService } from './global-service.service';
import { PasuraComponent } from './pasura/pasura.component';


import { DateAdapter} from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { MaterialModule} from '../material-module';
import { LoginComponent } from './login/login.component';
import { AuthenticationGuard as AuthGuard } 	from './app.routes.guard';
import { AntraegeComponent } from './antraege/antraege.component';
import { EinschaetzungComponent } from './einschaetzung/einschaetzung.component';
import { PersonenComponent } from './personen/personen.component';
import { KontakteComponent } from './kontakte/kontakte.component';
//import { SchadenfallComponent } from '/home/maurus/pasura/service/src/app/schadenfall/schadenfall.component';
import { SchadenfallComponent } from './schadenfall/schadenfall.component';

import { TokenInterceptor } from './auth/token.interceptor';

import { SchadenfaelleComponent } from './schadenfaelle/schadenfaelle.component';
import { FileArchivComponent } from './file-archiv/file-archiv.component';
import { TransportversicherungComponent } from './transportversicherung/transportversicherung.component';
import { BenutzerComponent } from './benutzer/benutzer.component';
import { LeistungComponent } from './leistung/leistung.component';
import { VersicherungPferdComponent } from './versicherung-pferd/versicherung-pferd.component';

import { OptionenPipe } from './optionen.pipe';


@NgModule({ declarations: [
        AppComponent,
        TarifComponent,
        PasuraComponent,
        LoginComponent,
        AntraegeComponent,
        EinschaetzungComponent,
        PersonenComponent,
        KontakteComponent,
        SchadenfaelleComponent,
        FileArchivComponent,
        TransportversicherungComponent,
        BenutzerComponent,
        LeistungComponent,
        VersicherungPferdComponent,
        SchadenfallComponent,
        OptionenPipe
    ],
    bootstrap: [AppComponent], 
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        ToastrModule.forRoot()], 
     providers: [
        GlobalService,
        AuthGuard,
        OptionenPipe,
        TokenInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        { provide: DateAdapter, useClass: AppDateAdapter },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class AppModule { }
